module.exports = __webpack_public_path__ + "img/82_2.99fc83ef.png";